import { render, staticRenderFns } from "./RecentActions.vue?vue&type=template&id=29458563&scoped=true&"
import script from "./RecentActions.vue?vue&type=script&lang=js&"
export * from "./RecentActions.vue?vue&type=script&lang=js&"
import style0 from "./RecentActions.vue?vue&type=style&index=0&id=29458563&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29458563",
  null
  
)

export default component.exports